import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import {
  AuthRoute,
  ConditionalRoute,
  CreateAccountPage,
  DirectLoginPage,
  EnterBarcodePage,
  EnterNewPinPage,
  LoginPage,
  LogoutPage,
  MainPage,
  PreregistrationPage,
  SSOPage,
} from '@app/components';
import { FEATURE, ROUTE } from '@app/constants';

export const AppRoutes: FC = () => (
  <Routes>
    <Route
      path={ROUTE.login}
      element={
        <AuthRoute>
          <LoginPage />
        </AuthRoute>
      }
    />
    <Route
      path={ROUTE.createAccount}
      element={
        <ConditionalRoute flagsToMatch={[{ name: FEATURE.preregistration }]}>
          <AuthRoute>
            <CreateAccountPage />
          </AuthRoute>
        </ConditionalRoute>
      }
    />
    <Route
      path={ROUTE.preregistration}
      element={
        <ConditionalRoute flagsToMatch={[{ name: FEATURE.preregistration }]}>
          <AuthRoute>
            <PreregistrationPage />
          </AuthRoute>
        </ConditionalRoute>
      }
    />
    <Route
      path={ROUTE.directLogin}
      element={
        <AuthRoute>
          <DirectLoginPage />
        </AuthRoute>
      }
    />
    <Route path={ROUTE.logout} element={<LogoutPage />} />
    <Route
      path={ROUTE.sso}
      element={
        <AuthRoute>
          <SSOPage />
        </AuthRoute>
      }
    />
    <Route
      path={ROUTE.enterNewPin}
      element={
        <AuthRoute>
          <EnterNewPinPage />
        </AuthRoute>
      }
    />
    <Route
      path={ROUTE.resetPinRoot}
      element={<Navigate replace to={ROUTE.enterBarcode} />}
    />
    <Route
      path={ROUTE.enterBarcode}
      element={
        <AuthRoute>
          <EnterBarcodePage />
        </AuthRoute>
      }
    />
    <Route path="*" element={<MainPage />} />
  </Routes>
);
